<template>
  <v-card>
    <v-card-title class="grey lighten-2 black--text mb-7">
      <v-icon class="ml-2">mdi-cash</v-icon>
      الممول
    </v-card-title>
    <!-- CONTENT -->
    <v-card-text class="pb-0">
      <v-container>
        <v-progress-linear
          v-if="loading"
          color="primary"
          indeterminate
          rounded
          height="6"
        ></v-progress-linear>

        <div v-else>
          <v-text-field
            dense
            outlined
            clearable
            class="mb-2"
            label="الرابط"
            hint="اضغط علي x لإخفاء الممول من صفحة الموقع"
            persistent-hint
            prepend-icon="mdi-link"
            v-model="form.sponsor_link"
          ></v-text-field>

          <v-file-input
            dense
            outlined
            accept="image/*"
            label="الصورة"
            prepend-icon="mdi-image"
            v-model="form.sponsor_image"
          ></v-file-input>

          <ul class="mr-10">
            <li>لإضافة ممول بدون رابط أدخل <code>#</code> في حقل الرابط.</li>
            <li>اضغط علي زر <code>X</code> لإخفاء الممول من صفحة الموقع.</li>
          </ul>
        </div>
      </v-container>
    </v-card-text>

  <!-- ACTIONS -->
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="secondary" elevation="1" dark @click="update(form)">حفظ</v-btn>
    </v-card-actions>
  </v-card>
</template>


<script>
export default {
  name: 'sponsor',

  data: function () {
    return {
      form: {},
      loading: false
    }
  },


  created() {
    this.fetchSponsorData();
  },


  methods: {
    fetchSponsorData() {
      this.loading = true;

      this.axios.get('/admin/content/sponsor')
        .then((response) => {
          this.form.sponsor_link = response.data.sponsor_link;
        })
        .catch((error) => {
          this.$bus.$emit('showSnackbar', {
            text: 'تعذر جلب بيانات الممول',
            color: 'accent'
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    update(form) {
      this.loading = true;

      let payload = new FormData;
      for (const property in form) {
        if (!form.hasOwnProperty(property) || form[property] == null) {
          continue;
        }
        payload.append(property, form[property]);
      }

      this.axios.post('/admin/content/sponsor', payload)
        .then(() => {
          this.$bus.$emit('showSnackbar', {
            text: 'تم تعديل بيانات الممول بنجاح',
            color: 'success'
          });
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
}
</script>